import type { ReactNode } from 'react';
import PhotoThumbnail from './PhotoThumbnail';
import type { PhotoLike, ApprovalStatus } from '../../types';

export type PhotoGridProps = {
  photos: PhotoLike[];
  onSelect: (index: number) => void;
  selectedIds?: Set<number>;
  creditMap?: Map<number, ApprovalStatus | undefined>;
  renderOverlay?: (photo: PhotoLike) => ReactNode;
  renderCaption?: (photo: PhotoLike) => ReactNode;
  columns?: number;
};

export default function PhotoGrid({ photos, onSelect, selectedIds = new Set(), creditMap = new Map(), renderOverlay, renderCaption, columns }: PhotoGridProps) {
  const gridClass = columns ? `photo-grid-container cols-${columns}` : 'photo-grid-container cols-auto';

  return (
    <div className={gridClass} style={{ display: 'grid', gap: '8px' }}>
      {photos.map((photo, index) => (
        <PhotoThumbnail
          key={photo.id}
          photo={photo}
          isSelected={selectedIds.has(photo.id)}
          status={creditMap.get(photo.id)}
          onClick={() => onSelect(index)}
          overlayAction={renderOverlay ? renderOverlay(photo) : null}
          renderCaption={renderCaption ? renderCaption(photo) : undefined}
        />
      ))}
    </div>
  );
}
